import { gql } from "@apollo/client";

export default gql`
  mutation verifyAccountPhoneNumber($organizationId: Int!, $code: String!) {
    verifyPhoneNumber(organizationId: $organizationId, code: $code) {
      membership {
        id
        phoneNumber
        phoneNumberVerified
        phoneNumberVerifiedAt
      }
    }
  }
`;
